import { useEffect, useState } from 'react'
import Heading from '../../component/Heading/Heading'
import TableComponent from '../../component/Table/TableComponent';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { resendEmail } from '../../services/admin-services/userService';
import Toast from '../../component/toastify/Index';
import deleteIcon from "../../assets/icons/trash.svg"
import { deleteClient, getClientList, inActiveClient, toggleClientStatus } from '../../services/admin-services/clientServices';
import { changeDateFormate } from '../../helper/changeDateFormate';
import { useTranslation } from 'react-i18next';
import CommonGradientSwitch from '../../component/switch/CommonSwitch';
import "../../styles/pages/client/clientList.scss";

const columns = [
    { field: 'firstName', headerName: 'First Name', translationKey: 'common_label_first_name' },
    { field: 'lastName', headerName: 'Last Name', translationKey: 'common_label_last_name' },
    { field: 'email', headerName: 'Email', translationKey: 'common_label_email' },
    { field: 'companyName', headerName: 'Company Name', translationKey: 'common_label_company_name' },
    { field: 'mobileNumber', headerName: 'Mobile Number', translationKey: 'common_label_mobile_number' },
    { field: 'referenceCode', headerName: 'Reference Code', translationKey: 'client_list_reference_code' },
    { field: 'subscription', headerName: 'Subscription', translationKey: 'client_list_subscription' },
    { field: 'startDate', headerName: 'Start Date', translationKey: 'client_list_start_date' },
    { field: 'endDate', headerName: 'End Date', translationKey: 'client_list_end_date' },
    { field: 'status', headerName: 'Status', translationKey: 'client_list_status' },
    { field: 'action', headerName: 'Action', translationKey: 'client_list_action' },
];

const ClientList = () => {
    const { t } = useTranslation();
    const [clients, setClients] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(0)

    const getAllClientRequestList = async (payload) => {
        const response = await getClientList(payload);
        setClients(response.client.filter(c => !!c.planFrequency));
        setTotalRecords(response?.totalRecords ? response?.totalRecords : 0)
    }

    useEffect(() => {
        getAllClientRequestList({ pageNo, perPage });
    }, [pageNo, perPage]);

    const handleResendInvitation = async (email) => {
        const response = await resendEmail(email);
        if (response?.isSuccess) {
            Toast(response?.message, "success");
            getAllClientRequestList();
        }
    }

    const handleDelete = async (id) => {
        const response = await deleteClient(id);
        if (response.isSuccess) {
            Toast(response?.message, "success");
            getAllClientRequestList();
        }
    }

    const handleActiveClient = async (id) => {
        const response = await inActiveClient(id);
        if (response.isSuccess) {
            Toast(response?.message, "success");
            getAllClientRequestList();
        }
    }

    const handleToggleClientStatus = async (id, status) => {
        const response = await toggleClientStatus(id, status);
        if (response.isSuccess) {
            Toast(response?.message, "success");
            getAllClientRequestList();
        }
    }

    return (
        <div className="users clientList">
            <div className="user-heading flex items-center justify-between">
                <Heading text={t('module_client_list')} className="user-heading" />
            </div>
            <div>
                <TableComponent
                    data={clients}
                    handleResendInvitation={handleResendInvitation}
                    setPageNo={setPageNo}
                    pageNo={pageNo}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    totalRecords={totalRecords}
                    columns={columns}
                    className={'client-table-max-height'}
                >
                    {clients?.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            <TableCell>{row.client.firstName}</TableCell>
                            <TableCell>{row.client.lastName}</TableCell>
                            <TableCell>{row.client.email}</TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.client.mobileNumber}</TableCell>
                            <TableCell>{row.client.referenceCode}</TableCell>
                            <TableCell>{row.subscriptionMetaData.planFrequency}</TableCell>
                            <TableCell>{changeDateFormate(row.subscriptionStartDate)}</TableCell>
                            <TableCell>{changeDateFormate(row.subscriptionEndDate)}</TableCell>
                            <TableCell
                                className={!row?.client.isDelete ? 'active-text' : 'inactive-text'}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: "center",
                                        gap: 1,
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {row.client.status
                                        ? t('user_active')
                                        :
                                        t('user_in_active')
                                    }
                                    <CommonGradientSwitch
                                        checked={row.client.status}
                                        onChange={(event) =>
                                            handleToggleClientStatus(row.client._id, event.target.checked)
                                        }
                                    />
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Typography
                                    className="action"
                                    classes="flex"
                                    alignItems={"center"}
                                    display={"flex"}
                                    gap={1}
                                >
                                    {/* <span>
                                        <img
                                            src={editIcon}
                                            alt="edit icon"
                                            className="edit-icon"
                                        />
                                    </span> */}
                                    {
                                        // row.client.status ?
                                        <span onClick={() => handleDelete(row.client._id)}>
                                            <img src={deleteIcon} alt="delete icon" />
                                        </span>
                                        // :
                                        // <span onClick={() => handleActiveClient(row.client._id)}>
                                        //     <PlaylistAddCheckCircleIcon sx={{ fontSize: '30px', color: "#00c853" }} />
                                        // </span>
                                    }
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableComponent>
            </div>
        </div>
    );
};

export default ClientList;